var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "show-close": true,
            visible: _vm.rangeInfoDialogVisible,
            title: _vm.codeTitle,
            top: "10vh",
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.rangeInfoDialogVisible = $event
            },
            close: _vm.clearForm,
          },
        },
        [
          _vm.isModify
            ? _c("div", { staticClass: "tip01" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("collectionCenter.tips")) +
                    "：" +
                    _vm._s(
                      _vm.$t("collectionCenter.startPostcodeCannotExceedEnd")
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
          _vm.isModify
            ? _c(
                "el-form",
                {
                  ref: "rangeInfoFormRef",
                  staticClass: "demo-rangeInfoForm",
                  attrs: { model: _vm.rangeInfoForm, "label-position": "top" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        rules: {
                          required: true,
                          message: _vm.$t("placeOrder.pleaseInput"),
                          trigger: ["blur", "change"],
                        },
                        label: _vm.$t("collectionCenter.pastePostcode"),
                        prop: "zipCodeValue",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: _vm.$t(
                            "collectionCenter.postcodeFormatInstructions"
                          ),
                          rows: "5",
                          type: "textarea",
                        },
                        on: {
                          input: _vm.handleZipCodeValueChange,
                          blur: _vm.zipCodeFil,
                        },
                        model: {
                          value: _vm.rangeInfoForm.zipCodeValue,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.rangeInfoForm,
                              "zipCodeValue",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "rangeInfoForm.zipCodeValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isModify
            ? _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "left",
                    "margin-bottom": "15px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.addForm },
                    },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.append")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "danger" },
                      on: { click: _vm.deleteAll },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.DeleteAll")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showProgress
            ? _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                !_vm.showResultDetails
                  ? _c(
                      "span",
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#4f504f",
                              "font-size": "14px",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("collectionCenter.systemExecutingTask")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("el-progress", {
                          staticStyle: { margin: "5px 0 10px" },
                          attrs: {
                            percentage: _vm.uploadProgress,
                            "stroke-width": 10,
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#4f504f",
                              "font-size": "14px",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "collectionCenter.taskCompletedCheckResult"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("el-progress", {
                          staticStyle: { margin: "5px 0 10px" },
                          attrs: { percentage: "100", "stroke-width": 10 },
                        }),
                        _vm.errorData && _vm.errorData.length > 0
                          ? _c(
                              "div",
                              { staticStyle: { color: "red" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "collectionCenter.importFailedPostcodes"
                                      )
                                    )
                                  ),
                                ]),
                                _c("br"),
                                _vm._l(_vm.errorData, function (item, index) {
                                  return _c("div", { key: index }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(index + 1) +
                                        ". " +
                                        _vm._s(item.errorRange) +
                                        "，" +
                                        _vm._s(item.errorMessage) +
                                        " "
                                    ),
                                  ])
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
                fit: true,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.ind"),
                  width: "80",
                  type: "index",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.startZipCode"),
                  prop: "startZip",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.endZipCode"),
                  prop: "endZip",
                  align: "center",
                },
              }),
              _vm.isModify
                ? _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.operation"),
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "collectionCenter.deleteSure"
                                    ),
                                  },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.delRow(scope.$index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#1d90ff",
                                        "font-size": "14px",
                                        cursor: "pointer",
                                      },
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("collectionCenter.Delete")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2289441022
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.isModify
            ? _c(
                "div",
                { staticStyle: { "text-align": "center", margin: "15px 0" } },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.clearForm } },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Close")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.saveForm },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }